import { FormControl, InputLabel, Select, SxProps, Theme } from "@mui/material";

const ToolbarSelect = ({
  label,
  children,
  value,
  onChange,
  sx,
}: {
  label: string;
  children: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
  sx?: SxProps<Theme>;
}) => {
  return (
    <FormControl sx={{ m: 1, minWidth: 120, flex: 1, ...sx }}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        defaultValue="all"
        label={label}
        SelectDisplayProps={{
          style: { padding: "8px 16px" },
        }}
      >
        {children}
      </Select>
    </FormControl>
  );
};

export default ToolbarSelect;
